/*----- Core -----*/
import React						from 'react'
import styled, { css }  from 'styled-components'
import PropTypes        from 'prop-types'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Device from '../../commons/Device'

/*----- Styles-----*/
const StyledHeroText = styled.article`
	padding: 16px;
	max-width: 400px;
	padding: 120px 0 120px 0;
	@media ${Device.sm} {
		max-width: 500px;
	}
	@media ${Device.md} {
		max-width: 800px;
	}
	.hero-text__text-container {
		position: relative;
		z-index: 1;
		max-width: 500px;
	}
	.hero-text__title {
		${ Montserrat(40, 600, 'grey') };
		line-height: 40px;
		margin: 0;
	}
	.hero-text__subtitle {
		${ Montserrat(20, 400, 'grey') };
		line-height: 26px;
		margin-top: 20px;
	}
	${props => props.invert && css`
		.hero-text__title, .hero-text__subtitle {
			color: white;
		}
  `}
	@media ${Device.md} {
		.hero-text__title { 
			font-size: 50px;
			line-height: 50px;
		}
		.hero-text__subtitle {
			font-size: 30px;
			line-height: 36px;
		}
	}
`/*----- Component -----*/
const HeroText = ({ title, subtitle, invert }) => (
  <StyledHeroText className="hero-text" invert={invert}>
		<div className="hero-text__text-container">
			<h1 className="hero-text__title">
				{ title }
			</h1>
			<h2 className="hero-text__subtitle">
				{ subtitle }
			</h2>
		</div>
  </StyledHeroText>
)
export default HeroText

/*----- PropTypes -----*/
HeroText.propTypes = {
  title:	  PropTypes.string.isRequired,
  subtitle:	PropTypes.string.isRequired,
  invert:  	PropTypes.bool
}
